// Demos hub copy — en / fr / es. EN strings verbatim from the original page.

export const DEMOS_COPY = {
  en: {
    docTitle: "Live Demos — Ask Your Business a Question | Ocean Data",
    eyebrow: "Live demos · no setup, no slides",
    h1a: "Ask. See the answer.",
    h1b: "Act.",
    heroSub:
      "Two working copilots, one fictional company, real questions from real seats. Everything below runs on sample data — the point is how it feels when the answer simply arrives.",
    steps: [
      { title: "Ask", body: "Tap a real question from a real seat — owner, sales, projects, or accounting." },
      { title: "See the answer", body: "Watch the copilot read the record and return a clear, role-shaped answer in seconds." },
      { title: "Act", body: "Follow-ups, drafts, and reminders are already prepared. You just approve." },
    ],
    demos: [
      {
        id: "hub-card-revenue",
        to: "/demos/revenue",
        name: "Sales & projects",
        hook: "What needs my attention today?",
        body: "Watch a business answer its own questions — what's stuck, what's behind, what to do next — with the follow-ups already prepared for each seat.",
        tags: ["Owner", "Sales", "Project Manager"],
      },
      {
        id: "hub-card-books",
        to: "/demos/books",
        name: "Your books",
        hook: "What can I invoice right now?",
        body: "Ask your numbers a plain question and get a plain answer — what's billable, what's overdue, where cash stands, and which work is actually profitable.",
        tags: ["Accounting · Billing", "Owner · Cash"],
      },
    ],
    tryDemo: "Try the demo",
    notePre: "Both demos show the same quiet idea from the",
    noteFlow: "before & after flow",
    noteMid: ": scattered chasing becomes one source of truth, and every role gets only its own view. Built on the",
    noteApproach: "FIX · CONNECT · AUTOMATE",
    notePost: "approach.",
    noteApproachTo: "/solutions",
    hreflangs: { "en-CA": "/demos", "fr-CA": "/fr/demos", es: "/es/demos", "x-default": "/demos" },
  },
  fr: {
    docTitle: "Démos en direct — Posez une question à votre entreprise | Ocean Data",
    eyebrow: "Démos en direct · sans installation, sans diapos",
    h1a: "Demandez. Voyez la réponse.",
    h1b: "Agissez.",
    heroSub:
      "Deux copilotes fonctionnels, une entreprise fictive, de vraies questions de vrais rôles. Tout ci-dessous roule sur des données d'exemple — l'important, c'est ce que ça fait quand la réponse arrive tout simplement.",
    steps: [
      { title: "Demandez", body: "Touchez une vraie question d'un vrai rôle — direction, ventes, projets ou comptabilité." },
      { title: "Voyez la réponse", body: "Regardez le copilote lire le dossier et revenir avec une réponse claire, adaptée au rôle, en quelques secondes." },
      { title: "Agissez", body: "Suivis, brouillons et rappels sont déjà préparés. Vous n'avez qu'à approuver." },
    ],
    demos: [
      {
        id: "hub-card-revenue",
        to: "/demos/revenue",
        name: "Ventes & projets",
        hook: "Qu'est-ce qui demande mon attention aujourd'hui ?",
        body: "Regardez une entreprise répondre à ses propres questions — ce qui est bloqué, ce qui est en retard, quoi faire ensuite — avec les suivis déjà préparés pour chaque rôle.",
        tags: ["Direction", "Ventes", "Chargé de projet"],
      },
      {
        id: "hub-card-books",
        to: "/demos/books",
        name: "Votre comptabilité",
        hook: "Qu'est-ce que je peux facturer tout de suite ?",
        body: "Posez une question simple à vos chiffres et recevez une réponse simple — ce qui est facturable, ce qui est en retard, où en est la trésorerie, et quel travail est vraiment rentable.",
        tags: ["Comptabilité · Facturation", "Direction · Trésorerie"],
      },
    ],
    tryDemo: "Essayer la démo",
    notePre: "Les deux démos montrent la même idée discrète que le",
    noteFlow: "flux avant & après",
    noteMid: " : la poursuite dispersée devient une seule source de vérité, et chaque rôle ne voit que sa propre vue. Bâti sur l'approche",
    noteApproach: "RÉPARER · CONNECTER · AUTOMATISER",
    notePost: ".",
    noteApproachTo: "/fr/solutions",
    hreflangs: { "en-CA": "/demos", "fr-CA": "/fr/demos", es: "/es/demos", "x-default": "/demos" },
  },
  es: {
    docTitle: "Demos en vivo — Pregunte a su empresa | Ocean Data",
    eyebrow: "Demos en vivo · sin instalación, sin diapositivas",
    h1a: "Pregunte. Vea la respuesta.",
    h1b: "Actúe.",
    heroSub:
      "Dos copilotos funcionando, una empresa ficticia, preguntas reales de roles reales. Todo lo de abajo corre sobre datos de ejemplo — el punto es cómo se siente cuando la respuesta simplemente llega.",
    steps: [
      { title: "Pregunte", body: "Toque una pregunta real de un rol real — dirección, ventas, proyectos o contabilidad." },
      { title: "Vea la respuesta", body: "Vea el copiloto leer el expediente y volver con una respuesta clara, adaptada al rol, en segundos." },
      { title: "Actúe", body: "Seguimientos, borradores y recordatorios ya están preparados. Usted solo aprueba." },
    ],
    demos: [
      {
        id: "hub-card-revenue",
        to: "/demos/revenue",
        name: "Ventas y proyectos",
        hook: "¿Qué necesita mi atención hoy?",
        body: "Vea una empresa responder sus propias preguntas — qué está atascado, qué está atrasado, qué hacer después — con los seguimientos ya preparados para cada rol.",
        tags: ["Dirección", "Ventas", "Jefe de proyecto"],
      },
      {
        id: "hub-card-books",
        to: "/demos/books",
        name: "Su contabilidad",
        hook: "¿Qué puedo facturar ahora mismo?",
        body: "Haga una pregunta simple a sus números y reciba una respuesta simple — qué es facturable, qué está vencido, cómo está la caja, y qué trabajo es realmente rentable.",
        tags: ["Contabilidad · Facturación", "Dirección · Caja"],
      },
    ],
    tryDemo: "Probar la demo",
    notePre: "Ambas demos muestran la misma idea discreta del",
    noteFlow: "flujo antes y después",
    noteMid: ": la persecución dispersa se vuelve una sola fuente de verdad, y cada rol ve solo su propia vista. Construido sobre el enfoque",
    noteApproach: "REPARAR · CONECTAR · AUTOMATIZAR",
    notePost: ".",
    noteApproachTo: "/es/soluciones",
    hreflangs: { "en-CA": "/demos", "fr-CA": "/fr/demos", es: "/es/demos", "x-default": "/demos" },
  },
};
